import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AdditionFieldsComponent } from 'shared/modules/addition-fields/addition-fields.component';
import { AngularModule } from 'shared/modules/angular/angular.module';
import { ControlsModule } from 'shared/modules/controls/controls.module';
import { DynamicFormModule } from 'shared/modules/dynamic-form/dynamic-form.module';
import { LayoutModule } from 'shared/modules/layout/layout.module';
import { MaterialModule } from 'shared/modules/material/material.module';
import { PipesModule } from 'shared/modules/pipes/pipes.module';
import { TableModule } from 'shared/modules/table/table.module';
import { TypographyModule } from 'shared/modules/typography/typography.module';
import { AdditionAddDialogComponent } from './addition-add-dialog/addition-add-dialog.component';
import { AdditionFormComponent } from './addition-add-dialog/addition-form/addition-form.component';

@NgModule({
  declarations: [
    AdditionFieldsComponent,
    AdditionAddDialogComponent,
    AdditionFormComponent,
  ],
  imports: [
    CommonModule,
    PipesModule,
    LayoutModule,
    TableModule,
    TypographyModule,
    MaterialModule,
    ReactiveFormsModule,
    ControlsModule,
    AngularModule,
    DynamicFormModule,
    TranslateModule,
  ],
  exports: [AdditionFieldsComponent],
})
export class AdditionFieldsModule {
}
